/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const TrainIconConfig = {
  name: 'TrainIcon',
  height: 512,
  width: 448,
  svgPath: 'M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(TrainIconConfig);
//# sourceMappingURL=train-icon.js.map